"use client";

import { useEffect, useState } from "react";

import { getEventProposalQuotes } from "../_logic/actions/estimate-actions";
import type { ProposalQuote } from "../_logic/types";

/**
 * The venue quotes on the estimate's event, so its cities price with real proposal rates.
 * @param eventId - The linked or opening event, or null.
 * @returns The quotes for that event; empty without an event or until they load.
 * @throws Never.
 */
export function useEventProposals(eventId: number | null): ProposalQuote[] {
  // States
  const [loaded, setLoaded] = useState<{ eventId: number; quotes: ProposalQuote[] } | null>(null);

  // Effects
  useEffect(() => {
    if (eventId === null) return;
    let cancelled = false;
    void getEventProposalQuotes(eventId)
      .catch(() => [])
      .then((quotes) => {
        if (!cancelled) setLoaded({ eventId, quotes });
      });
    return () => {
      cancelled = true;
    };
  }, [eventId]);

  return loaded && loaded.eventId === eventId ? loaded.quotes : [];
}
